export default "__VITE_ASSET__f$mhTsRv__"